import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormBuilder } from 'shared-components/forms/form';
import { RadioGroup } from '../../elements-inputs/radio-group';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class DeclineOfferModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: '',
      isProcessing: false
    };

    this.modalBody = this.modalBody.bind(this);
    this.declineOffer = this.declineOffer.bind(this);
    this.declineOfferCb = this.declineOfferCb.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount () {
    const { iosWebView, scrollTopIOS } = this.props;

    if (iosWebView) {
      scrollTopIOS();
    }
  }

  declineOffer (form, cb, refs) {
    const { declineOfferAction, isUpdate } = this.props;
    const payload = {};

    this.setState({ isProcessing: true });

    payload.reason = refs.radio.returnRadioGroupValue();
    declineOfferAction(payload, cb, isUpdate);
  }

  declineOfferCb (response) {
    const { bookingID, iosWebView, closeIOSModal, finalCb, contracts } = this.props;
    if (200 === response.statusCode) {
      const spaceRental = _.find(contracts, { type: 'SPACE_RENTAL' }) || {};
      const spaceRentalBooking = _.get(spaceRental, 'meta.booking', {});
      spaceRentalBooking.listing = _.get(spaceRental, 'meta.listing', {});

      analyticsIntegrations.declineOfferConfirmed(spaceRentalBooking, contracts);

      // action for ios webview
      if (iosWebView) {
        closeIOSModal();
        return finalCb();
      }
      return this.context.router.push({ pathname: `/inbox/${bookingID}` });
    }

    this.setState({
      errorText: this.props.intl.formatMessage({ id: 'inbox_review_offer.decline_offer_modal.something_wrong', defaultMessage: 'Something went wrong, please try again.' }),
      isProcessing: false
    });
  }

  closeModal () {
    this.props.toggleModal('');
  }

  modalBody () {
    const { isUpdate } = this.props;
    const { isProcessing } = this.state;

    return (
      <div className="decline-offer-modal col-xs-12" style={{ paddingBottom: 40 }}>
        <p className="gutter">
          <FormattedMessage
            id='inbox_review_offer.decline_offer_modal.tell_declined'
            defaultMessage="Tell the host why you're declining their offer."
          />
        </p>
        <FormBuilder
          formname="decline-offer-form"
          formStyle="modal-plus gutter margin-lg-left"
          formInputs={[{ custom: () => {
            return (
              <RadioGroup
                isRequired
                ref="radio"
                inputData={[
                  {
                    ID: 'another-space',
                    value: 'I found another space.',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.decline_offer_modal.found_space', defaultMessage: 'I found another space.' })
                  },
                  {
                    ID: 'cancelled',
                    value: 'My event is cancelled.',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.decline_offer_modal.event_canceled', defaultMessage: 'My event is cancelled.' })
                  },
                  {
                    ID: 'dates-changing',
                    value: 'My dates are changing.',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.decline_offer_modal.dates_changing', defaultMessage: 'My dates are changing.' })
                  },
                  {
                    ID: 'space-too-expensive',
                    value: 'The space is too expensive.',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.decline_offer_modal.space_expensive', defaultMessage: 'The space is too expensive.' })
                  },
                  {
                    ID: 'add-ons-too-expensive',
                    value: 'The add-ons are too expensive or incorrect.',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.decline_offer_modal.addons_expensive', defaultMessage: 'The add-ons are too expensive or incorrect.' })
                  },
                  {
                    ID: 'other',
                    value: '',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.decline_offer_modal.other', defaultMessage: 'Other' }),
                    collectUserInput: true
                  }
                ]}
                groupName="decline-offer-reason"
              />);
          } }]}
          submitAction={ this.declineOffer }
          submitCallback={ this.declineOfferCb }
          isButtonDisabled={ isProcessing }
          isDisableSpinning={ false }
          buttonText={ this.props.intl.formatMessage({ id: 'inbox_review_offer.decline_offer_modal.decline_button', defaultMessage: 'Decline' }) }
          errorText={ this.state.errorText }
          beforeCTA={
            <div>
              <hr style={{ marginTop: 0 }} />
              <p className="text-center">{ isUpdate
                ? <FormattedMessage id='inbox_review_offer.decline_offer_modal.updates_not_applied' defaultMessage="The updates will not be applied and your booking will revert to the original details." />
                : ''}
              </p>
            </div>
          }
        />
      </div>
    );
  }

  render () {
    const { iosWebView, whichModal } = this.props;
    return (
      <div>
        {
          iosWebView && ('declineOfferModal' === whichModal) ?
            <div id="decline-update-modal" className="decline-update-modal-ios">
              <button className="btn-link remove-click-styling pull-right ico ico-sm icon-close-sidebar" onClick={this.closeModal} />
              <div className="text-center">
                <h4>
                  <FormattedMessage
                    id='inbox_review_offer.decline_offer_modal.decline_price'
                    defaultMessage="Decline Price Offer"
                  />
                </h4>
              </div>
              {
                this.modalBody()
              }
            </div>
            :
            <BootstrapModal
              {...this.props}
              addCloseIcon
              show
              modalID="decline-update-modal"
              modalSize="sm-size"
              modalType="standard"
              header={ <h4><FormattedMessage id='inbox_review_offer.decline_offer_modal.decline_price_modal' defaultMessage="Decline Price Offer" /></h4> }
              body={ this.modalBody() }
            />
        }
      </div>
    );
  }
}


DeclineOfferModal.propTypes = {
  accessToken: PropTypes.string,
  bookingID: PropTypes.string,
  isUpdate: PropTypes.bool,
  closeIOSModal: PropTypes.func,
  finalCb: PropTypes.func,
  declineOfferAction: PropTypes.func,
  iosWebView: PropTypes.bool,
  scrollTopIOS: PropTypes.func,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string,
  contracts: PropTypes.array,
  booking: PropTypes.object,
  intl: intlShape
};

DeclineOfferModal.contextTypes = {
  router: PropTypes.object
};

exports.DeclineOfferModal = injectIntl(DeclineOfferModal);
